<template>
  <form @submit.prevent="handleSubmit">
    <div id="content-to-debit-pdf" class="pdf-container web-container-mode" ref="domiciliacionContent">
      <div class="page">
        <div class="container-fluid" id="content-direct-debit">
          <div class="row">
            <div class="col-12">
              <!-- <img src="@/assets/bbva-logo.png" alt="BBVA Logo" class="logo" /> -->
            </div>
          </div>
          <div class="row spacy-lateral">
            <div class="col-12">
              <h3 class="title">FORMATO PARA SOLICITAR LA DOMICILIACIÓN "ANEXO D"</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <!-- <div class="lugar-fecha">Lugar y Fecha</div> -->
              <div class="form-row lugar-fecha">
                <label>Lugar y Fecha:</label>
                <input type="text" class="underline-input" v-model="placeRequest" required />
                <input type="date" class="underline-input" v-model="dateRequest" required />
              </div>
            </div>
          </div>
          <div class="row bank-inf spacy-lateral">
            <div class="col-12">
              <strong>BBVA BANCOMER, S.A.</strong>
            </div>
            <div class="col-12">
              <strong>INSTITUCIÓN DE BANCA MÚLTIPLE</strong>
            </div>
            <div class="col-12">
              <strong>GRUPO FINANCIERO BBVA BANCOMER</strong>
            </div>
          </div>
          <div class="row spacy-lateral">
            <div class="col-12">
              <p class="text-justify mt-4">
                Solicito y autorizo que con base en la información que se indica en esta comunicación se realicen cargos
                periódicos en mi cuenta conforme a lo siguiente:
              </p>
            </div>
          </div>
          <div class="row spacy-lateral">
            <div class="col-12">

              <ol class="form-list">
                <li>
                  Nombre del proveedor del bien, servicio o crédito, según corresponda, que pretende pagarse:
                  KVF GROUP SA DE CV.
                </li>
                <li>
                  Bien, servicio o crédito a pagar: Crédito personal 01 –
                  <span class="line">{{ store.form?.product?.description }}</span>
                </li>
                <li>
                  Datos autorizados para la domiciliación
                  <span class="line">{{ store.form?.prospectus?.personType?.peopleTypeId === 1 ? `
                    ${store.form?.prospectus?.addressAccredited?.street}
                    ${store.form?.prospectus?.addressAccredited?.exteriorNumber}
                    ${store.form?.prospectus?.addressAccredited?.interiorNumber}
                    ${store.form?.prospectus?.addressAccredited?.district}` :
                    `${store.form?.prospectus?.addressLegalRepresentative?.street}
                    ${store.form?.prospectus?.addressLegalRepresentative?.exteriorNumber}
                    ${store.form?.prospectus?.addressLegalRepresentative?.interiorNumber}
                    ${store.form?.prospectus?.addressLegalRepresentative?.district}
                    ` }}</span>

                  <div class="sub-section">
                    <p class="mt-4">Periodicidad: <span class="line short"></span></p>
                    <p>Días de cobro: <span class="line short">{{ day }}</span></p>
                    <p>
                      Monto Autorizado:
                      <span class="line medium">{{ amount }} {{ amountWord }}.</span>
                    </p>

                    <p class="mt-4">Banco: {{ store.form?.quotations?.directDebits?.authorizedPersonName }}</p>
                    <p>Cuenta: {{ store.form?.quotations?.directDebits?.accountNumber }}</p>
                    <p>Clave: {{ store.form?.quotations?.directDebits?.clabe }}</p>
                  </div>
                </li>
                <li>
                  Esta autorización es por plazo de <span class="line tiny">{{store.form?.quotations?.totalTerm}}</span> meses a partir del
                  <span class="line short">{{ $filters.formatDate(store.form?.quotations?.disbursementDate, "dd 'de' MMMM 'del' yyy") }}</span> o hasta cubrir el importe total establecido en el
                  Anexo B.
                </li>
              </ol>
            </div>
          </div>
          <div class="row spacy-lateral">
            <div class="col-12">
              <p class="text-justify mt-4">
                Estoy enterado de que en cualquier momento podré solicitar la cancelación de la presente domiciliación
                sin costo a mi cargo.
              </p>
            </div>
          </div>
          <div class="row spacy-lateral">
            <div class="col-12">
              <p><strong>Atentamente,</strong></p>
            </div>
          </div>
          <div class="row spacy-lateral">
            <div class="col-12">
              <div class="signature-debit">
                <div class="signature-line-debit">_________________________________________</div>
                <p><strong>{{ store.form?.prospectus?.generalInfo?.businessName === null ?
                  `${store.form?.prospectus?.generalInfo?.firstName} ${store.form?.prospectus?.generalInfo?.lastName}
                    ${store.form?.prospectus?.generalInfo?.mothersMaidenName}` :
                    store.form?.prospectus?.generalInfo?.businessName}}</strong></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-actions">
      <button class="download-btn">Descargar PDF</button>
    </div>
  </form>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance, watch, nextTick } from 'vue';
import { useDirectDebitStore } from '@/pinia/LoanApplications/Legal/useDirectDebitStore.module';

const store = useDirectDebitStore();
const domiciliacionContent = ref(null);
const directDebit = {};

// Acceder a la instancia de la app
const app = getCurrentInstance();
const filters = app?.appContext.config.globalProperties.$filters;

const amount = computed({
  get: () => filters?.formatNumber(store.form?.quotations?.creditAmount),
  set: (value) => {
    if (store.form?.quotations) {
      store.form.quotations.creditAmount = filters?.formatNumber(value);
    }
  }
});

const amountWord = computed(() => {
  const monto = store.form?.quotations?.creditAmount;
  if (monto === undefined || monto === null) return '';

  const numero = Number(monto);
  if (isNaN(numero)) return '';

  // Capitaliza la primera letra (ej: "veinticinco..." → "Veinticinco...")
  const letras = filters?.numeroALetras(numero);
  return letras.charAt(0).toUpperCase() + letras.slice(1);
});

/**Fecha de disposición */
// Obtener la fecha actual desde el store (o null si no existe)
const getCurrentDate = () => {
  //const dateStr = store.form?.quotations?.disbursementDate;
  const dateStr = store.form?.promissoryNotes?.paymentDate;
  return dateStr ? new Date(dateStr) : null;
};

// Actualizar el valor de disbursementDate en el store
const updateDisbursementDate = (newDate) => {
  if (store.form?.quotations) {
    store.form.quotations.disbursementDate = newDate.toISOString();
  }
};

// Día (getter + setter)
const day = computed({
  get: () => getCurrentDate()?.getDate() || '',
  set: (newDay) => {
    const currentDate = getCurrentDate() || new Date();
    currentDate.setDate(Number(newDay));
    updateDisbursementDate(currentDate);
  },
});

const placeRequest = computed({
  get: () => store.form?.directDebitRequest?.placeRequest,
  set: (value) => {
    if (store.form?.directDebitRequest) {
      store.form.directDebitRequest.placeRequest = value;
    }
  }
});

const dateRequest = computed({
  get: () => {
    if(!store.form?.directDebitRequest?.dateRequest) return '';
    return filters?.formatDateForInput?.(store.form.directDebitRequest.dateRequest) || store.form.directDebitRequest.dateRequest;
  },
  set: (value) => {
    if (store.form?.directDebitRequest) {
      store.form.directDebitRequest.dateRequest = value;
    }
  }
});

const handleSubmit = () => {
  store.setContentS(domiciliacionContent.value);
  store.saveData();
};
</script>

<style lang="css" scoped>
#content-to-debit-pdf {
  overflow: visible;
  font-family: Calibri, sans-serif;
  color: #000 !important;
}

.page {
  padding: 20px;
  background-color: white;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  margin-bottom: 25px;
  page-break-after: always;
}

.page:last-child {
  page-break-after: auto;
}

.content-direct-debit {
  padding: 30px;
}

.download-btn {
  padding: 10px 20px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  transition: background-color 0.3s;
}

.download-btn:hover {
  background-color: #369f6e;
}

.logo {
  width: 130px;
  margin-bottom: 20px;
}

.title {
  text-align: center;
  /*font-size: 13.5pt;*/
  font-size: 14pt;
  font-weight: bold;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.lugar-fecha {
  text-align: right;
  font-weight: bold;
  margin-bottom: 25px;
  font-size: 12pt;
}

.bank-info {
  text-align: left;
  margin-bottom: 20px;
  line-height: 1;
  font-size: 12pt;
}

.form-list {
  /*padding-left: 1.2em;*/
  margin-top: 15px;
}

.form-list li {
  margin-bottom: 15px;
  text-align: justify;
}

.sub-section {
  padding-left: 1.5em;
  margin-top: 10px;
}

.sub-section p {
  margin-bottom: 8px;
}

.text-justify {
  text-align: justify;
}

.mt-4 {
  margin-top: 1.5rem;
}

.mt-5 {
  margin-top: 3rem;
}

.signature-debit {
  margin-top: 20px;
}


.form-row.row-rigth {
  display: inherit;
  text-align: right;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  margin-right: 0px;
  margin-left: 0px;
}

.underline-input {
  /*padding: 5px 0;*/
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  margin-right: 20px;
  /*min-width: 300px;*/
  /*min-width: 35%;*/
}

.line {
  border-bottom: 1px solid black;
}

.pdf-mode .spacy-lateral {
  padding-right: 60px !important;
  padding-left: 60px !important;
}


/* Estilos para el contenedor */
.lugar-fecha {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  /*gap: 15px;*/
  margin-bottom: 25px;
  font-size: 12pt;
}

/* Estilos para los inputs */
.underline-input {
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  padding-bottom: 2px;
  /*min-width: 120px;*/
  min-width: 100px;
  width: 80px;
}

/* Estilo específico para el date picker */
.underline-input[type="date"] {
  min-width: 140px;
  width: 80px;
}

/* Ajuste para alinear la línea base del texto */
.lugar-fecha label {
  margin-right: 4px;
}
</style>